import React, { useEffect, useState } from "react";
import { GetKYCList, PostKYCList } from "../../Services/KYCStatus";
import { MdVerified } from "react-icons/md";
import { FaHourglassHalf } from "react-icons/fa";
import KYCSkeleton from "./KYCSkeleton";

const KYCStatus = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [updateId, setUpdateId] = useState(null);
  const fetchKYCList = async () => {
    setLoading(true);
    try {
      const res = await GetKYCList();

      setData(res?.data?.data || []);
      setLoading(false);
    } catch (err) {
      throw new Error(err);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchKYCList();
  }, []);
  const handleVerifyKYC = async (id) => {
    try {
      const res = await PostKYCList({ kyc_id: id });

      if (res?.data?.response_code === 200) {
        await fetchKYCList();
      }
    } catch (err) {
      throw new Error(err);
    }
  };

  return (
    <div>
      <div className="max-w-8xl mx-auto px-1 py-1">
        <p className="md:text-2xl text-lg font-bold text-black pb-2">
          KYC Details
        </p>

        {loading ? (
          <KYCSkeleton />
        ) : data?.length > 0 ? (
          <div className="overflow-x-auto bg-white shadow-md rounded-lg border border-gray-200">
            <table className="w-full text-sm text-left text-gray-700 min-w-[800px]">
              <thead className="text-xs text-gray-500 uppercase bg-gray-50 border-b">
                <tr>
                  <th className="px-4 py-1">User ID</th>
                  <th className="px-4 py-1">Aadhaar Number</th>
                  <th className="px-4 py-1">PAN Number</th>
                  <th className="px-4 py-1">Aadhaar Front Image</th>
                  <th className="px-4 py-1">Aadhar Back Image</th>
                  <th className="px-4 py-1">PAN Image</th>
                  <th className="px-4 py-1">Created Date</th>
                  <th className="px-4 py-1">Verification</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((kyc) => (
                  <tr
                    key={kyc?.id}
                    className="border-b hover:bg-gray-50 transition-all"
                  >
                    <td className="px-4 py-1">{kyc?.user}</td>
                    <td className="px-4 py-1">{kyc.adhar_num}</td>
                    <td className="px-4 py-1">{kyc.pan_num}</td>
                    <td className="px-4 py-1 ">
                      <img
                        loading="lazy"
                        src={kyc?.adhar_front_image}
                        alt="Aaadhar Front"
                        className="w-14 h-12 object-cover rounded border"
                      />
                    </td>
                    <td className="px-4 py-1">
                      <img
                        loading="lazy"
                        src={kyc?.adhar_back_image}
                        alt="Aaadhar Back"
                        className="w-14 h-12 object-cover rounded border"
                      />
                    </td>
                    <td className="px-4 py-1">
                      <img
                        loading="lazy"
                        src={kyc?.pan_image}
                        alt="pan"
                        className="w-14 h-12 object-cover rounded border"
                      />
                    </td>
                    <td className="px-4 py-1">
                      {new Date(kyc?.created_date).toLocaleDateString()}{" "}
                      {new Date(kyc?.created_date).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </td>
                    <td className="px-4 py-1">
                      {kyc?.is_verified_by_admin ? (
                        <div
                          onClick={() => handleVerifyKYC(kyc?.id)}
                          className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-600"
                        >
                          <MdVerified size={14} />
                          Verified
                        </div>
                      ) : (
                        <button
                          onClick={() => handleVerifyKYC(kyc?.id)}
                          className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-semibold bg-yellow-100 text-yellow-600 hover:bg-yellow-200 transition"
                        >
                          <FaHourglassHalf size={14} />
                          Verify Now
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className=" flex flex-col items-center justify-center py-12">
            <img
              loading="lazy "
              alt="no data"
              src="https://img.freepik.com/free-vector/hand-drawn-no-data-illustration_23-2150570252.jpg?semt=ais_hybrid&w=740"
              className="w-48 h-48 object-contain pb-4"
            />
            <p className="text-gray-500 text-center text-sm">
              No KYC records found.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default KYCStatus;
